import React from 'react';
import {formatarReal} from '../../util/numberUtil';

const ModalExcluirCentroCusto = ({excluir, centroCustoSelecionado, limparSelecaoCentroCusto}) => (
    <div className="modal fade" id="modalExcluirCentroCusto" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>
                        Deseja excluir o centro de custo
                        <strong> {centroCustoSelecionado ? centroCustoSelecionado.ocorrencia : ''}</strong>
                    </p>
                    <p>
                        no valor de
                        <strong> {centroCustoSelecionado ? formatarReal(centroCustoSelecionado.valorTotalGasto) : '0.00'} </strong> reais?
                    </p>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-outline-secondary" data-dismiss="modal"
                            onClick={limparSelecaoCentroCusto}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja" data-dismiss="modal" onClick={excluir}>
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export default ModalExcluirCentroCusto;
